// import { Crud } from "@/api";
import { LoaderFunctionArgs } from "react-router-dom";

export default async function dashboardPricingLoader({
  request,
}: LoaderFunctionArgs) {
  // const url = new URL(request.url);
  // const email = url.searchParams.get("email") || undefined;

  // const [users] = await Promise.all([
  //   Crud.users.getAll({ email: email ? { contains: email } : undefined }),
  // ]);

  // return { users };
  return null;
}
